import { SxProps, Theme } from '@mui/material';

// Common styles used across pages
export const styles = {
  // Layout
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3,
  } as SxProps<Theme>,

  filterSection: {
    mb: 3,
  } as SxProps<Theme>,

  errorAlert: {
    mb: 2,
  } as SxProps<Theme>,

  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
  } as SxProps<Theme>,

  // Table
  tableHead: {
    backgroundColor: '#f5f5f5',
  } as SxProps<Theme>,

  tableHeaderCell: {
    fontWeight: 'bold',
  } as SxProps<Theme>,

  tableRow: {
    cursor: 'pointer',
  } as SxProps<Theme>,

  // Icons
  iconMargin: {
    mr: 1,
  } as SxProps<Theme>,

  // Chips and badges
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  } as SxProps<Theme>,
};

// Color constants
export const colors = {
  tableHeaderBg: '#f5f5f5',
};
